var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('p',[_vm._v("© Balcony Games. All rights reserved.")]),_c('p',[_c('a',{attrs:{"href":"/privacy.html"}},[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('a',{attrs:{"href":"/terms.html"}},[_vm._v("Terms")])])])
}]

export { render, staticRenderFns }